/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react'
import { Fragment, ReactElement } from 'react';
import { genJyuuGothicBold } from '../../fonts/FontFace'
import { RecipesComponentProp } from '../../types'

type Props = {
  component: RecipesComponentProp
  key: number
}

function RecipesComponent({ component }: Props): ReactElement {
  const recipeStyle = (i: number) =>
    css`
      box-sizing: border-box;
      width: 50%;
      padding: ${i % 2 === 0 ? '12px 6px 5px 0' : '12px 0 5px 6px'};
    `
  return (
    <Fragment>
      <div css={recipeComponentStyle} className="recipes_component">
        {component.title && (
          <h2 css={titleStyle(component.titleColor)}>
            {component.title.split(/\n/).map((leadElement, i) => (
              <Fragment key={i}>
                {leadElement}
                <br />
              </Fragment>
            ))}
          </h2>
        )}
        <ul css={recipesWrapperStyle}>
          {component.recipes.map((recipe, i) => (
            <li css={recipeStyle(i)} key={i}>
              <a css={recipeLinkStyle} href={recipe.path}>
                <div css={recipeImageWrapperStyle}>
                  <img src={recipe.image.url} width="170" height="170" css={recipeImageStyle} />
                </div>
                <div css={recipeNameStyle}>{recipe.name}</div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </Fragment>
  );
}

const recipeComponentStyle = css`
  margin-bottom: 24px;
  padding: 24px 12px 0 12px;
`

const titleStyle = (titleColor: string) => css`
  ${genJyuuGothicBold}
  font-size: 20px;
  color: ${titleColor};
  text-align: center;
  margin-top: 0;
  line-height: 30px;
`

const recipesWrapperStyle = css`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
`

const recipeLinkStyle = css`
  display: block;
`

const recipeImageWrapperStyle = css`
  border-radius: 4px;
  position: relative;
`

const recipeImageStyle = css`
  display: block;
  width: 100%;
  height: auto;
`

const recipeNameStyle = css`
  margin: 8px;
  text-decoration: underline;
  font-size: 14px;
  font-weight: bold;
  line-height: 120%;
  color: #3c1c1c;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`

export default RecipesComponent
